import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Dialog, DialogBody, DialogFooter } from '@blueprintjs/core';
import { Formik } from 'formik';
import { useMemo } from 'react';
import * as Yup from 'yup';
import { useChartData } from '../../context/ChartContext';
import { useDispatch } from '../../context/DispatchContext';
import Button from '../../elements/Button';
import ReactTable from '../../elements/ReactTable/ReactTable';
import FormikInput from '../../elements/formik/FormikInput';
const styles = {
    input: {
        padding: '0.25rem 0.5rem',
    },
    column: {
        padding: '2px',
    },
};
const toleranceValidationSchema = Yup.array()
    .of(Yup.object({ value: Yup.number().required() }))
    .min(1);
export function SetShiftToleranceModal(props) {
    const { isOpen, ...otherPros } = props;
    if (!isOpen) {
        return;
    }
    return _jsx(InnerSetShiftToleranceModal, { ...otherPros });
}
function InnerSetShiftToleranceModal(props) {
    const { onClose } = props;
    const { correlations } = useChartData();
    const dispatch = useDispatch();
    function onSaveHandler(data) {
        const tolerance = {};
        for (const { atom, value } of data) {
            tolerance[atom] = value;
        }
        dispatch({
            type: 'SET_CORRELATIONS_TOLERANCE',
            payload: {
                tolerance,
            },
        });
        onClose?.();
    }
    const COLUMNS = useMemo(() => [
        {
            Header: '#',
            style: { width: '25px', textAlign: 'center', ...styles.column },
            accessor: (_, index) => index + 1,
        },
        {
            Header: 'Atom',
            style: { width: '25px', textAlign: 'center', ...styles.column },
            accessor: 'atom',
        },
        {
            Header: 'Value',
            style: { padding: 0, ...styles.column },
            Cell: ({ row }) => {
                return (_jsx(FormikInput, { name: `${row.index}.value`, style: { input: styles.input }, type: "number", checkErrorAfterInputTouched: false }));
            },
        },
    ], []);
    const tolerances = correlations?.options?.tolerance || {};
    const tolerancesData = Object.keys(tolerances).map((atom) => ({
        atom,
        value: tolerances[atom],
    }));
    return (_jsx(Dialog, { isOpen: true, title: "Shift tolerances", onClose: onClose, style: { width: 400 }, children: _jsx(Formik, { initialValues: tolerancesData, onSubmit: onSaveHandler, validationSchema: toleranceValidationSchema, children: ({ isValid, handleSubmit }) => (_jsxs(_Fragment, { children: [_jsx(DialogBody, { children: _jsx(ReactTable, { data: tolerancesData, columns: COLUMNS, emptyDataRowText: "No atoms" }) }), _jsx(DialogFooter, { children: _jsx(Button.Done, { onClick: () => handleSubmit(), disabled: !isValid, children: "Set shift tolerances" }) })] })) }) }));
}
